var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.835 19.125L9.89079 16.5V35.8961C9.89079 36.7819 10.6122 37.5 11.5021 37.5H37.2888C38.1787 37.5 38.9001 36.7819 38.9001 35.8961V28.75L24.835 19.125Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.835 2.5H11.5021C10.6122 2.5 9.89079 3.21808 9.89079 4.10387V11.25L24.835 20L32.7466 22.625L38.9001 20V11.25L24.835 2.5Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89079 11.25L24.835 11.25L24.835 20L9.89079 20V11.25Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5864 9.5H9.89079V31.375H20.5864C21.4752 31.3721 22.1949 30.6557 22.1978 29.7711V11.1039C22.1949 10.2193 21.4752 9.50288 20.5864 9.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7074 10.375H9.89079V32.25H19.7074C20.5961 32.2471 21.3158 31.5307 21.3187 30.6461V11.9789C21.3158 11.0943 20.5961 10.3779 19.7074 10.375Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7074 10.375H9.89079V30.5H19.7074C20.5961 30.4971 21.3158 29.7807 21.3187 28.8961V11.9789C21.3158 11.0943 20.5961 10.3779 19.7074 10.375Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8283 10.375H9.89079V30.5H18.8283C19.717 30.4971 20.4367 29.7807 20.4396 28.8961V11.9789C20.4367 11.0943 19.717 10.3779 18.8283 10.375Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71143 10.375H18.8283C19.7182 10.375 20.4396 11.0931 20.4396 11.9789L20.4396 28.0211C20.4396 28.9069 19.7182 29.625 18.8283 29.625H2.71143C1.82151 29.625 1.1001 28.9069 1.1001 28.0211V11.9789C1.1001 11.0931 1.82151 10.375 2.71143 10.375Z",
    fill: "url(#paint0_linear_5174_401788)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09057 25.2133L9.48027 19.9851L6.37452 14.7859H8.87282L10.5677 18.1109C10.7242 18.4267 10.8314 18.6612 10.8894 18.8161H10.9114C11.0227 18.5641 11.1399 18.3194 11.263 18.082L13.0748 14.7876H15.3683L12.1834 19.9563L15.4492 25.2132H13.0089L11.0512 21.5636C10.959 21.4083 10.8807 21.2452 10.8173 21.0763H10.7883C10.731 21.2418 10.6549 21.4003 10.5615 21.5488L8.54583 25.2133H6.09057Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2888 2.5H24.835L24.835 11.25L38.9001 11.25V4.10387C38.9001 3.21808 38.1787 2.5 37.2888 2.5Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.835 20H38.9001V28.75H24.835V20Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5174_401788",
    x1: 7.66673,
    y1: 0.221389,
    x2: 29.5967,
    y2: 41.2418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/Excel_Icon.71a3628452a3b37472a5ff676b08c8ec.svg";
export { ForwardRef as ReactComponent };